/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { unsetUserData } from '../../user/actions';
import { VisitedLinksState } from './types';

const initialState: VisitedLinksState = {};

const visitedLinksSlice = createSlice({
  name: 'visitedLinks',
  initialState,
  reducers: {
    setEducatorsAppVisited: (state, { payload }: PayloadAction<boolean>) => {
      state.educatorsApp = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(unsetUserData, () => initialState);
  },
});

export default visitedLinksSlice;
